import React, { useEffect, useRef, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import useSocket from "../../../hooks/useSocket";
import GalaxyLayout from "../../client/components/layout/GalaxyLayout";
import "../../../assets/galaxy/RangBaz.css";
import axiosInstance from "../../../utils/axiosInstance";
import { setUserData } from "../../../store/userSlice";
import { useDispatch, useSelector } from "react-redux";

export default function HiLowGalaxy() {
  const [chipActive, setChipActive] = useState(100);
  const [gameRoundId, setGameRoundId] = useState("");
  const [array_list, set_array_list] = useState([]);
  const [betList, setBetList] = useState([]);

  const [highAmount, setHighAmount] = useState(0);
  const [snapAmount, setSnapAmount] = useState(0);
  const [lowAmount, setLowAmount] = useState(0);
  const [redAmount, setRedAmount] = useState(0);
  const [blackAmount, setBlackAmount] = useState(0);
  const [firstSetAmount, setFirstSetAmount] = useState(0);
  const [secoundSetAmount, setSecoundSetAmount] = useState(0);
  const [thirdSetAmount, setThirdSetAmount] = useState(0);
  const [betCount, setBetCount] = useState(0);

  const [resultList, setResultList] = useState([]);
  const dispatch = useDispatch();

  const [highWin, setHighWin] = useState(false);
  const [snapWin, setSnapWin] = useState(false);
  const [lowWin, setLowWin] = useState(false);
  const [redWin, setRedWin] = useState(false);
  const [blackWin, setBlackWin] = useState(false);
  const [firstSetWin, setFirstSetWin] = useState(false);
  const [secondSetWin, setSecondSetWin] = useState(false);
  const [thirdSetWin, setThirdSetWin] = useState(false);

  let eventStatus = "";
  let roundId = "";
  let timeLeft = "";
  let isCallSend = false;


  const { data, isConnected } = useSocket({
    marketId: null,
    mtype: "galaxy",
    type: "hilo_galaxy"
  });
  console.log("Socket data:", data);

  const payloadResult = data?.data?.result;
  const updateUserData = async (userData) => {
    await dispatch(setUserData(userData));
  };

  const getBetList = async () => {
    if (roundId !== "") {
      try {
        let betObj = {};
        betObj.catmid = roundId;
        betObj.game_name = "hilo_galaxy";
        const response = await axiosInstance.post(
          "/casino/get-casino-bet-list",
          betObj
        );

        setBetList(response.data);
        console.log("betList->", response.data);
      } catch (error) { }
    }
  };

  const placeBet = async () => {
    let totalAmount = 0;
    if (array_list != "" && array_list.length > 0) {
      for (let j = 0; j < array_list.length; j++) {
        let obj = array_list[j];
        totalAmount = totalAmount + obj.amount;
      }

      console.log("totalAmount->", totalAmount);
      console.log("placeBet->", array_list);
      console.log("roundId->", roundId);

      try {
        let betObj = {};
        betObj.game_name = "hilo_galaxy";
        betObj.catmid = roundId;
        betObj.betPlaceArr = array_list;
        betObj.game_type = 10;

        set_array_list([]);

        const response = await axiosInstance.post(
          "/casino/place-bet-casino-multiple",
          betObj
        );
        if (
          response.data !== undefined &&
          response.data !== null &&
          response.data.status !== undefined &&
          response.data.status !== null
        ) {
          getBetList();
          fetchUserData();
        }
      } catch (error) {
        if (error.response.data !== undefined && error.response.data !== null) {
          if (
            error.response.data.status !== undefined &&
            error.response.data.status !== null &&
            error.response.data.status === false
          ) {
            let errorMessage = error.response.data.message;
            let messageObj = {};
            messageObj.status = false;
            messageObj.message = errorMessage;
          }
        }
      }
    }
  };

  let highCard = 0;
  let lowCard = 0;
  let snapCard = 0;

  let redCard = 1.95;
  let blackCard = 1.95;

  let firstSet = 2.89;
  let secoundSet = 2.89;
  let thirdSet = 2.89;

  let suspend1 = "";
  let b1 = 0;
  let betfairOdds = null;
  let gameCard = "";
  let resultCard = "";
  let resultCardNo = 0;
  let result = "";
  let resultCard1 = 1;
  let resultCard2 = 1;

  if (
    data != null &&
    data.data?.data !== null &&
    data.data?.data !== undefined
  ) {
    betfairOdds = data.data.data;
    //console.log(betfairOdds);
    updateUserData(data?.user);

    highCard = betfairOdds.b1;
    lowCard = betfairOdds.b2;
    snapCard = betfairOdds.b3;

    roundId = betfairOdds.cat_mid;
    eventStatus = betfairOdds.evt_status;
    result = betfairOdds.result;

    timeLeft = betfairOdds.left_time;
    if (timeLeft == 1) {
      timeLeft = 0;
    }
    timeLeft = parseInt(timeLeft);
    suspend1 = betfairOdds.suspend1;
    if (timeLeft <= 2) {
      suspend1 = 1;
    }
    b1 = betfairOdds.b1;
    gameCard = betfairOdds.c1;
    resultCard = betfairOdds.c2;

    if (resultCard != "1") {
      let spitCard = resultCard.split("");
      let resultCardVal = spitCard[0];
      if (resultCardVal == "J") {
        resultCardVal = 11;
      }
      if (resultCardVal == "Q") {
        resultCardVal = 12;
      }
      if (resultCardVal == "K") {
        resultCardVal = 13;
      }
      resultCardNo = parseInt(resultCardVal);
    }

    if (resultCard !== "1") {
      //console.log("resultCard->", resultCard);
      if (result === 1) {
        resultCard1 = resultCard;
        resultCard2 = 1;
      } else {
        resultCard2 = resultCard;
        resultCard1 = 1;
      }
    }

    if (array_list.length > 0 && timeLeft < 3 && !isCallSend) {
      placeBet();
      isCallSend = true;
    }

    //console.log("result->", result);
  }

  useEffect(() => {
    if (!payloadResult) return;

    if (payloadResult !== "") {
      //console.log("payloadResult->", payloadResult);
      setResultList([]);
      setResultList(payloadResult);
    }
  }, [payloadResult]);
  const resetGame = () => {
    setHighAmount(0);
    setSnapAmount(0);
    setLowAmount(0);
    setRedAmount(0);
    setBlackAmount(0);
    setFirstSetAmount(0);
    setSecoundSetAmount(0);
    setThirdSetAmount(0);
    setBetList([]);
  };

  useEffect(() => {
    //setGameRoundId()
    if (gameRoundId == "") {
      setGameRoundId(roundId);
      getBetList();
    }
    if (gameRoundId !== roundId) {
      setGameRoundId(roundId);
      resetGame();
    }
  }, [roundId]);

  useEffect(() => {
    if (eventStatus == "CLOSED") {
      //resetGame();
    }
  }, [eventStatus]);

  const undo = () => {
    if (array_list !== null && array_list.length > 0) {
      let firstElement = array_list[0];
      let teamname = firstElement.teamname;
      if (teamname == "high") {
        setHighAmount(0);
      } else if (teamname == "snap") {
        setSnapAmount(0);
      } else if (teamname == "low") {
        setLowAmount(0);
      } else if (teamname == "red") {
        setRedAmount(0);
      } else if (teamname == "black") {
        setBlackAmount(0);
      } else if (teamname == "2345") {
        setFirstSetAmount(0);
      } else if (teamname == "6789") {
        setSecoundSetAmount(0);
      } else if (teamname == "jqka") {
        setThirdSetAmount(0);
      }

      let newArr = array_list.slice(1);
      set_array_list(newArr);
    }
  };

  const initializeBet = (betType, teamname, type, price) => {
    if (price > 0) {
      let amt = 0;
      if (teamname == "high") {
        amt = highAmount + chipActive;
        setHighAmount(amt);
      } else if (teamname == "snap") {
        amt = snapAmount + chipActive;
        setSnapAmount(amt);
      } else if (teamname == "low") {
        amt = lowAmount + chipActive;
        setLowAmount(amt);
      } else if (teamname == "red") {
        amt = redAmount + chipActive;
        setRedAmount(amt);
      } else if (teamname == "black") {
        amt = blackAmount + chipActive;
        setBlackAmount(amt);
      } else if (teamname == "2345") {
        amt = firstSetAmount + chipActive;
        setFirstSetAmount(amt);
      } else if (teamname == "6789") {
        amt = secoundSetAmount + chipActive;
        setSecoundSetAmount(amt);
      } else if (teamname == "jqka") {
        amt = thirdSetAmount + chipActive;
        setThirdSetAmount(amt);
      }

      let indexFound = -1;
      let arr = [];
      if (array_list.length > 0) {
        for (let i = 0; i < array_list.length; i++) {
          let obj = array_list[i];
          if (obj.teamname == teamname) {
            indexFound = i;
            break;
          }
        }

        if (indexFound !== -1) {
          const newArr = array_list.filter((_, index) => index !== indexFound);
          //console.log("newArr->", newArr);
          let obj = {};
          obj.market_type = betType;
          obj.teamname = teamname;
          obj.bettype = type;
          obj.odds = price;
          obj.amount = amt;
          obj.catmid = roundId;
          arr = [...newArr, obj];
          set_array_list(arr);
        } else {
          let objNew = {};
          objNew.market_type = betType;
          objNew.teamname = teamname;
          objNew.bettype = type;
          objNew.odds = price;
          objNew.amount = amt;
          objNew.catmid = roundId;
          arr = [...array_list, objNew];
          set_array_list(arr);
        }
      } else {
        let obj = {};
        obj.market_type = betType;
        obj.teamname = teamname;
        obj.bettype = type;
        obj.odds = price;
        obj.amount = amt;
        obj.catmid = roundId;
        arr = [...array_list, obj];
        set_array_list(arr);
      }

      //console.log("arr->", arr);
      if (array_list.length > 0) {
        setBetCount(array_list.length);
      }
    }
  };

  const displayResult = (result) => {
    let returnTxt = "";
    if (result == 1) {
      returnTxt = "HI";
    } else if (result == 2) {
      returnTxt = "LO";
    } else {
      returnTxt = "SN";
    }

    return returnTxt;
  };

  const fetchUserData = async () => {
    //console.log("Fetching events...");
    try {
      const response = await axiosInstance.get("/user");
      //console.log("user-response->",response);
      if (response.data !== "") {
        await dispatch(setUserData(response.data));
      }
    } catch (error) {
      console.error("Error fetching events:", error);
    }
  };

  const displayBG = (result) => {
    let returnTxt = "";
    if (result == 1) {
      returnTxt = "rgb(76, 175, 80)";
    } else if (result == 2) {
      returnTxt = "rgb(211, 47, 47)";
    } else {
      returnTxt = "";
    }

    return returnTxt;
  };

  const clearWinner = () => {
    setHighWin(false);
    setSnapWin(false);
    setLowWin(false);

    setRedWin(false);
    setBlackWin(false);

    setFirstSetWin(false);
    setSecondSetWin(false);
    setThirdSetWin(false);
  };

  const getCardValue = (card) => {
    if (!card || card === "1") return 0;

    let value = card.slice(0, -2);

    if (value === "A") return 1;
    if (value === "J") return 11;
    if (value === "Q") return 12;
    if (value === "K") return 13;

    return Number(value);
  };

  const getSuit = (card) => {
    if (!card || card === "1") return "";

    return card.slice(-2);
  };

  useEffect(() => {
    clearWinner();

    if (!data?.data?.data) return;
    const odds = data.data.data;
    if (odds.evt_status !== "CLOSED") return;
    const card = odds.c2;
    if (!card || card === "1" || odds.result === "") return;

    const value = getCardValue(card);
    const suit = getSuit(card);

    if (odds.result === 1) setHighWin(true);
    else if (odds.result === 2) setLowWin(true);
    else if (odds.result === 3) setSnapWin(true);

    if (suit === "DD" || suit === "SS") setRedWin(true);
    else setBlackWin(true);

    if (value >= 2 && value <= 5) setFirstSetWin(true);
    else if (value >= 6 && value <= 9) setSecondSetWin(true);
    else if (value === 1 || value >= 11) setThirdSetWin(true);
  }, [data]);

  return (
    <GalaxyLayout>
      <div class="container mt-4" id="rbc-app">
        <div>
          <div class="tabs-section">
            <ul class="nav nav-tabs mobile-Tab nav-tabs-glxy">
              <li class="nav-item rbc-games-tab" data-id="0">
                <Link class="nav-link active" to="/galaxy-casino/1">
                  <span class="tab-icon">🎮</span>
                  All Games
                  <span class="badge bg-warning text-dark">6</span>
                </Link>
              </li>
              <li class="nav-item rbc-games-tab" data-id="1">
                <Link class="nav-link " to="/galaxy-casino/2">
                  <span class="tab-icon">🎮</span>
                  Crash
                  <span class="badge bg-warning text-dark">1</span>
                </Link>
              </li>
              <li class="nav-item rbc-games-tab" data-id="3">
                <Link class="nav-link " to="/galaxy-casino/3">
                  <span class="tab-icon">🎮</span>
                  Card
                  <span class="badge bg-warning text-dark">5</span>
                </Link>
              </li>{" "}
            </ul>

            <ul class="nav nav-tabs desktop-tab nav-tabs-glxy">
              <li class="nav-item rbc-games-tab" data-id="0">
                <Link class="nav-link active" to="/galaxy-casino/1">
                  <span class="tab-icon">🎮</span>
                  All Games
                  <span class="badge bg-warning text-dark">6</span>
                </Link>
              </li>
              <li class="nav-item rbc-games-tab" data-id="1">
                <Link class="nav-link " to="/galaxy-casino/2">
                  <span class="tab-icon">🎮</span>
                  Crash
                  <span class="badge bg-warning text-dark">1</span>
                </Link>
              </li>
              <li class="nav-item rbc-games-tab" data-id="3">
                <Link class="nav-link " to="/galaxy-casino/3">
                  <span class="tab-icon">🎮</span>
                  Card
                  <span class="badge bg-warning text-dark">5</span>
                </Link>
              </li>{" "}
            </ul>
          </div>

          <div id="rbc-game-view">
            <div class="container-fluid RBC-Jetx-MainContainer">
              <div class="RBC-Jetx-LeftPanel">
                {Object.keys(resultList).map((key) => (
                  <div
                    style={{ backgroundColor: displayBG(resultList[key]) }}
                    className="resultbox"
                  >
                    {displayResult(resultList[key])}
                  </div>
                ))}

                {/*{Object.keys(resultList).map((key) => (
                  <div
                    className="resultbox"
                    style={{
                      backgroundColor:
                        resultList[key] == 1
                          ? "rgb(76, 175, 80)"
                          : "rgb(211, 47, 47)"
                    }}
                  >
                    {resultList[key] === 1 ? "HI" : "LO"}
                  </div>
                ))}*/}
              </div>
              <div class="RBC-Jetx-CenterPanel">
                <div
                  class="RBC-Jetx-GameScreen B-height scroll-containeraviator"
                  style={{
                    background:
                      "linear-gradient(rgb(52, 5, 11), rgb(2, 17, 30))"
                  }}
                >
                  <div class="RBC-7UD-table">
                    <div class="RBC-HiLo-container">
                      <div
                        class="RBC-HiLo-arrow"
                        style={{ transform: "rotate(180deg)" }}
                      >
                        <svg
                          viewBox="0 0 100 120"
                          style={{ transform: "rotate(360deg)" }}
                        >
                          <path d="M30,50 L30,0 L70,0 L70,50 L100,50 L50,120 L0,50 Z"></path>
                        </svg>

                        {resultCard1 &&
                          (() => {
                            let resultCardImage = `../assets/galaxy/img/cards3/${resultCard1}.svg`;
                            return (
                              <img
                                class="highcardmbl"
                                src={resultCardImage}
                                alt="Card Image"
                              />
                            );
                          })()}
                      </div>
                      <div class="RBC-HiLo-center-image">
                        <span id="game-cards11">
                          {gameCard &&
                            (() => {
                              let cardImage = `../assets/galaxy/img/cards3/${gameCard}.svg`;
                              return (
                                <img
                                  id="img3"
                                  src={cardImage}
                                  alt="Card Image"
                                />
                              );
                            })()}
                        </span>
                      </div>
                      <div class="RBC-HiLo-arrow">
                        <svg viewBox="0 0 100 120">
                          <path d="M30,50 L30,0 L70,0 L70,50 L100,50 L50,120 L0,50 Z"></path>
                        </svg>

                        {resultCard2 &&
                          (() => {
                            let resultCardImage = `../assets/galaxy/img/cards3/${resultCard2}.svg`;
                            return (
                              <img src={resultCardImage} alt="Card Image" />
                            );
                          })()}
                      </div>
                    </div>
                  </div>
                  <div
                    className={
                      eventStatus == "OPEN"
                        ? "overlayaviatorx-galaxy"
                        : "overlayaviatorx-galaxy hide"
                    }
                  >
                    <div class="overlay-contentx-galaxy">
                      <span class="overlay-textaviatorx-glaxy">
                        <b style={{ color: "white", fontSize: "18px" }}>
                          Place Bets in <span id="game-time">{timeLeft}</span>
                        </b>
                      </span>
                    </div>
                  </div>
                  <div class="waveStrength-3">
                    <div
                      class="wv4 wave"
                      style={{ borderTopColor: "rgb(192, 192, 192)" }}
                    >
                      <div
                        class="wv3 wave"
                        style={{ borderTopColor: "rgb(192, 192, 192)" }}
                      >
                        <div
                          class="wv2 wave"
                          style={{ borderTopColor: "rgb(192, 192, 192)" }}
                        >
                          <div class="wv1 wave"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="round-id-container">
                    HiLow &nbsp;<span id="round-id">{roundId}</span>
                    <span class="info-icon openPopUpDetail">ⓘ</span>
                  </div>
                  <div class="Connectedclients-glxy mt-1">
                    <span class="user-icon"></span>{" "}
                    <b>
                      <span id="UsersCount" class="number">
                        23
                      </span>
                    </b>
                  </div>
                </div>
                <div class="relative">
                  <div class="RBC-2-chip-odds-view-ctn-glaxy desktop-tab">
                    <div class="RBC-2-chip-odds-view-layer">
                      <div class="t-l-ctn col-3">
                        <div class="total-bets">
                          <span
                            class="text"
                            style={{ color: "#b97f2b", fontSize: "12px" }}
                          >
                            Total Bet
                          </span>
                          <span
                            class="t-count total-bets2"
                            style={{ color: "#b97f2b", fontSize: "12px" }}
                          >
                            {" "}
                            {betCount}
                          </span>
                        </div>
                      </div>
                      <div class="chipDeck col-6">
                        <div class="chip-ctn">
                          <div id="fadeIn" class="show-stakes">
                            <div class="chips-layer">
                              <div
                                onClick={() => setChipActive(100)}
                                className={
                                  chipActive === 100
                                    ? "cdChip active"
                                    : "cdChip noActive"
                                }
                              >
                                <img
                                  src="../assets/galaxy/img/chip1.svg"
                                  alt=""
                                  class="chipimg"
                                />{" "}
                                <span class="cdChipSpan" dataval="100">
                                  100
                                </span>
                              </div>
                              <div
                                onClick={() => setChipActive(500)}
                                className={
                                  chipActive === 500
                                    ? "cdChip active"
                                    : "cdChip noActive"
                                }
                              >
                                <img
                                  src="../assets/galaxy/img/chip2.svg"
                                  alt=""
                                  class="chipimg"
                                />{" "}
                                <span class="cdChipSpan" dataval="500">
                                  500
                                </span>
                              </div>
                              <div
                                onClick={() => setChipActive(1000)}
                                className={
                                  chipActive === 1000
                                    ? "cdChip active"
                                    : "cdChip noActive"
                                }
                              >
                                <img
                                  src="../assets/galaxy/img/chip3.svg"
                                  alt=""
                                  class="chipimg"
                                />{" "}
                                <span class="cdChipSpan" dataval="1000">
                                  1k
                                </span>
                              </div>
                              <div
                                onClick={() => setChipActive(2000)}
                                className={
                                  chipActive === 2000
                                    ? "cdChip active"
                                    : "cdChip noActive"
                                }
                              >
                                <img
                                  src="../assets/galaxy/img/chip4.svg"
                                  alt=""
                                  class="chipimg"
                                />{" "}
                                <span class="cdChipSpan" dataval="2000">
                                  2k
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="ure-btn col-3">
                        <div class="undo-ctn undoFunc" onClick={() => undo()}>
                          <img
                            src="../assets/galaxy/img/undo-icon.svg"
                            alt=""
                            class="undo-icon"
                          />
                          <span>Undo</span>
                        </div>
                        <div
                          class="reset-ctn resetFunc"
                          onClick={() => resetGame()}
                        >
                          <img
                            src="../assets/galaxy/img/reset-icon.svg"
                            alt=""
                            class="reset-icon"
                          />
                          <span>Reset</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="RBC-2-chip-odds-view-ctn-glaxy mobile-View">
                    <div class="RBC-2-chip-odds-view-layer">
                      <div class="t-l-ctn col-12">
                        <div class="total-bets">
                          <span
                            class="text"
                            style={{ color: "#b97f2b", fontSize: "12px" }}
                          >
                            Total Bet
                          </span>{" "}
                          <span
                            class="t-count total-bets2"
                            style={{ color: "#b97f2b", fontSize: "12px" }}
                          >
                            0
                          </span>
                        </div>
                        <div
                          class="undo-ctn undoFunc"
                          style={{ marginLeft: "40px" }}
                          onClick={() => undo()}
                        >
                          <img
                            src="../assets/galaxy/img/undo-icon.svg"
                            alt=""
                            class="undo-icon"
                          />
                          <span>Undo</span>
                        </div>
                        <div
                          class="reset-ctn resetFunc"
                          onClick={() => resetGame()}
                        >
                          <img
                            src="../assets/galaxy/img/reset-icon.svg"
                            alt=""
                            class="reset-icon"
                          />
                          <span>Reset</span>
                        </div>
                      </div>
                    </div>
                    <div class="chipDeck col-12">
                      <div class="chip-ctn">
                        <div id="fadeIn" class="show-stakes">
                          <div class="chips-layer">
                            <div
                              onClick={() => setChipActive(100)}
                              className={
                                chipActive === 100
                                  ? "cdChip active"
                                  : "cdChip noActive"
                              }
                            >
                              <img
                                src="../assets/galaxy/img/chip1.svg"
                                alt=""
                                class="chipimg"
                              />{" "}
                              <span class="cdChipSpan" dataval="100">
                                100
                              </span>
                            </div>
                            <div
                              onClick={() => setChipActive(500)}
                              className={
                                chipActive === 500
                                  ? "cdChip active"
                                  : "cdChip noActive"
                              }
                            >
                              <img
                                src="../assets/galaxy/img/chip2.svg"
                                alt=""
                                class="chipimg"
                              />{" "}
                              <span class="cdChipSpan" dataval="500">
                                500
                              </span>
                            </div>
                            <div
                              onClick={() => setChipActive(1000)}
                              className={
                                chipActive === 1000
                                  ? "cdChip active"
                                  : "cdChip noActive"
                              }
                            >
                              <img
                                src="../assets/galaxy/img/chip3.svg"
                                alt=""
                                class="chipimg"
                              />{" "}
                              <span class="cdChipSpan" dataval="1000">
                                1K
                              </span>
                            </div>
                            <div
                              onClick={() => setChipActive(2000)}
                              className={
                                chipActive === 2000
                                  ? "cdChip active"
                                  : "cdChip noActive"
                              }
                            >
                              <img
                                src="../assets/galaxy/img/chip4.svg"
                                alt=""
                                class="chipimg"
                              />{" "}
                              <span class="cdChipSpan" dataval="2000">
                                2k
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="body-HiLo-Rnr">
                    <div class="HILI-RNR-container">
                      <div class="HILI-RNR-row">
                        <div
                          class="HILI-RNR-box HILI-RNR-high span3details"
                          data-teamname="high"
                          data-market-type="m"
                          data-bettype="b"
                          onClick={() =>
                            initializeBet("m", "high", "b", highCard)
                          }
                        >
                          HIGH{" "}
                          <span id="b1" class="odd">
                            {highCard}
                          </span>
                          <div
                            className={
                              highAmount > 0
                                ? "Rou-image-container-glaxy"
                                : "Rou-image-container-glaxy hide"
                            }
                          >
                            <img
                              src="../assets/galaxy/img/chip1.svg"
                              alt="Winner Icon"
                              className="rol-winner-icon"
                            />
                            <span class="Rou-image-text">{highAmount}</span>
                          </div>
                          <span
                            className={
                              highWin
                                ? "zero-value-glaxy"
                                : "zero-value-glaxy hides"
                            }
                          >
                            <img
                              src="../assets/galaxy/img/roul-winner.webp"
                              alt="Zero Icon"
                              class="zero-icon"
                            />
                          </span>
                        </div>
                        <div
                          class="HILI-RNR-box HILI-RNR-snap  span3details"
                          data-teamname="snap"
                          data-market-type="f"
                          data-bettype="b"
                          onClick={() =>
                            initializeBet("m", "snap", "b", snapCard)
                          }
                        >
                          SNAP{" "}
                          <span id="b3" class="odd">
                            {snapCard}
                          </span>
                          <div
                            className={
                              snapAmount > 0
                                ? "Rou-image-container-glaxy"
                                : "Rou-image-container-glaxy hide"
                            }
                          >
                            <img
                              src="../assets/galaxy/img/chip1.svg"
                              alt="Winner Icon"
                              class="rol-winner-icon"
                            />
                            <span class="Rou-image-text">{snapAmount}</span>
                          </div>
                          <span
                            className={
                              snapWin
                                ? "zero-value-glaxy"
                                : "zero-value-glaxy hides"
                            }
                          >
                            <img
                              src="../assets/galaxy/roul-winner.webp"
                              alt="Zero Icon"
                              class="zero-icon"
                            />
                          </span>
                        </div>
                        <div
                          class="HILI-RNR-box HILI-RNR-low span3details"
                          data-teamname="low"
                          data-market-type="m"
                          data-bettype="b"
                          onClick={() =>
                            initializeBet("m", "low", "b", lowCard)
                          }
                        >
                          LOW{" "}
                          <span id="b2" class="odd">
                            {lowCard}
                          </span>
                          <div
                            className={
                              lowAmount > 0
                                ? "Rou-image-container-glaxy"
                                : "Rou-image-container-glaxy hide"
                            }
                          >
                            <img
                              src="../assets/galaxy/img/chip1.svg"
                              alt="Winner Icon"
                              class="rol-winner-icon"
                            />
                            <span class="Rou-image-text">{lowAmount}</span>
                          </div>
                          <span
                            className={
                              lowWin
                                ? "zero-value-glaxy"
                                : "zero-value-glaxy hides"
                            }
                          >
                            <img
                              src="../assets/galaxy/roul-winner.webp"
                              alt="Zero Icon"
                              class="zero-icon"
                            />
                          </span>
                        </div>
                      </div>
                      <div class="HILI-RNR-row">
                        <div
                          class="HILI-RNR-box HILI-RNR-red span3details"
                          data-teamname="red"
                          data-market-type="f"
                          data-bettype="b"
                          onClick={() =>
                            initializeBet("f", "red", "b", redCard)
                          }
                          style={{ backgroundColor: "rgb(211, 47, 47)" }}
                        >
                          ♥♥ Red <span class="odd">{redCard}</span>
                          <div
                            className={
                              redAmount > 0
                                ? "Rou-image-container-glaxy"
                                : "Rou-image-container-glaxy hide"
                            }
                          >
                            <img
                              src="../assets/galaxy/img/chip1.svg"
                              alt="Winner Icon"
                              class="rol-winner-icon"
                            />
                            <span class="Rou-image-text">{redAmount}</span>
                          </div>
                          <span
                            className={
                              redWin
                                ? "zero-value-glaxy"
                                : "zero-value-glaxy hides"
                            }
                          >
                            <img
                              src="../assets/galaxy/roul-winner.webp"
                              alt="Zero Icon"
                              class="zero-icon"
                            />
                          </span>
                        </div>
                        <div
                          class="HILI-RNR-box HILI-RNR-black span3details"
                          data-teamname="black"
                          data-market-type="f"
                          data-bettype="b"
                          style={{ backgroundColor: "black" }}
                          onClick={() =>
                            initializeBet("f", "black", "b", blackCard)
                          }
                        >
                          ♣♣ Black <span class="odd">{blackCard}</span>
                          <div
                            className={
                              blackAmount > 0
                                ? "Rou-image-container-glaxy"
                                : "Rou-image-container-glaxy hide"
                            }
                          >
                            <img
                              src="../assets/galaxy/img/chip1.svg"
                              alt="Winner Icon"
                              class="rol-winner-icon"
                            />
                            <span class="Rou-image-text">{blackAmount}</span>
                          </div>
                          <span
                            className={
                              blackWin
                                ? "zero-value-glaxy"
                                : "zero-value-glaxy hides"
                            }
                          >
                            <img
                              src="../assets/galaxy/img/roul-winner.webp"
                              alt="Zero Icon"
                              class="zero-icon"
                            />
                          </span>
                        </div>
                      </div>
                      <div class="HILI-RNR-row">
                        <div
                          class="HILI-RNR-box HILI-RNR-cards span3details"
                          data-teamname="2345"
                          data-market-type="f"
                          data-bettype="b"
                          onClick={() =>
                            initializeBet("f", "2345", "b", firstSet)
                          }
                        >
                          ♣ ♥ 2 3 4 5 <span class="odd">{firstSet}</span>
                          <div
                            className={
                              firstSetAmount > 0
                                ? "Rou-image-container-glaxy"
                                : "Rou-image-container-glaxy hide"
                            }
                          >
                            <img
                              src="../assets/galaxy/img/chip1.svg"
                              alt="Winner Icon"
                              class="rol-winner-icon"
                            />
                            <span class="Rou-image-text">{firstSetAmount}</span>
                          </div>
                          <span
                            className={
                              firstSetWin
                                ? "zero-value-glaxy"
                                : "zero-value-glaxy hides"
                            }
                          >
                            <img
                              src="../assets/galaxy/img/roul-winner.webp"
                              alt="Zero Icon"
                              class="zero-icon"
                            />
                          </span>
                        </div>
                        <div
                          class="HILI-RNR-box HILI-RNR-cards span3details"
                          data-teamname="6789"
                          data-market-type="f"
                          data-bettype="b"
                          onClick={() =>
                            initializeBet("f", "6789", "b", secoundSet)
                          }
                        >
                          ♣ ♥ 6 7 8 9 <span class="odd">{secoundSet}</span>
                          <div
                            className={
                              secoundSetAmount > 0
                                ? "Rou-image-container-glaxy"
                                : "Rou-image-container-glaxy hide"
                            }
                          >
                            <img
                              src="../assets/galaxy/img/chip1.svg"
                              alt="Winner Icon"
                              class="rol-winner-icon"
                            />
                            <span class="Rou-image-text">
                              {secoundSetAmount}
                            </span>
                          </div>
                          <span
                            className={
                              secondSetWin
                                ? "zero-value-glaxy"
                                : "zero-value-glaxy hides"
                            }
                          >
                            <img
                              src="../assets/galaxy/img/roul-winner.webp"
                              alt="Zero Icon"
                              class="zero-icon"
                            />
                          </span>
                        </div>
                        <div
                          class="HILI-RNR-box HILI-RNR-cards span3details"
                          data-teamname="jqka"
                          data-market-type="f"
                          data-bettype="b"
                          onClick={() =>
                            initializeBet("f", "jqka", "b", thirdSet)
                          }
                        >
                          ♣ ♥ J Q K A <span class="odd">{thirdSet}</span>
                          <div
                            className={
                              thirdSetAmount > 0
                                ? "Rou-image-container-glaxy"
                                : "Rou-image-container-glaxy hide"
                            }
                          >
                            <img
                              src="../assets/galaxy/img/chip1.svg"
                              alt="Winner Icon"
                              class="rol-winner-icon"
                            />
                            <span class="Rou-image-text">{thirdSetAmount}</span>
                          </div>
                          <span
                            className={
                              thirdSetWin
                                ? "zero-value-glaxy"
                                : "zero-value-glaxy hides"
                            }
                          >
                            <img
                              src="../assets/galaxy/img/roul-winner.webp"
                              alt="Zero Icon"
                              class="zero-icon"
                            />
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className={`overlayRoulettelock-galaxy
                     ${suspend1 == 1 ? "" : "hides"}`}
                  >
                    <div style={{ textAlign: "center" }}>
                      <svg
                        focusable="false"
                        aria-hidden="true"
                        viewBox="0 0 24 24"
                        data-testid="LockIcon"
                        class="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium lock-icon css-vubbuv"
                        style={{ width: "70px", filter: "invert(0)" }}
                      >
                        <path d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"></path>
                      </svg>{" "}
                    </div>
                  </div>
                </div>
              </div>
              <div class="RBC-Jetx-RightPanel">
                <table class="RBC-Jetx-Table">
                  <thead>
                    <tr>
                      <th>Runner</th>
                      <th>Price</th>
                      <th>Size</th>
                    </tr>
                  </thead>
                  <tbody id="refreshhistory">
                    {betList &&
                      betList !== null &&
                      betList !== undefined &&
                      betList !== "" &&
                      betList.map((bet) => (
                        <tr>
                          <th style={{ textTransform: "uppercase" }}>
                            {bet.rnrname}
                          </th>
                          <th>{bet.rate}</th>
                          <th>{bet.lib}</th>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <style>
        {`
          .zero-icon{
            width: 36px;
            height: 36px;
          }
             `}
      </style>
    </GalaxyLayout>
  );
}
